import * as angular from "angular";

export class ObjectListenersService {
  listeners: any = {};

  constructor() {
  }

  addListener(base, id, callback) {
    if (!this.listeners[base + '/' + id]) {
      this.listeners[base + '/' + id] = [];
    }

    this.listeners[base + '/' + id].push(callback);
  }

  callListeners(base, id) {
    if (this.listeners[base + '/' + id]) {
      this.listeners[base + '/' + id].forEach((elem) => {
        elem();
      });
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .service('objectListenersService', ObjectListenersService);
